import {
  CREATE_DELIVERYITEM,
  UPDATE_DELIVERYITEM,
  LOAD_DELIVERYITEM,
  REMOVE_LISTS,
  LOAD_DELIVERYITEM_DETAIL
} from "./actions";
import * as moment from "moment";

const initialState = {
  lists: [],
  total: 1,
  loading: false,
  detailLoading: false,
  draw: -1,
  selectedDeliveryItem: {
    state: 5,
    files: null,
    job_type: 1,
    channel: 1,
    uploader: [],
    order_code_prefix: "",
    order_code: "",
    remark: "",
    end_warranty_date: moment().format("YYYY-MM-DD"),
    file_path: "",
    detailData: []
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_LISTS:
      return initialState;
    case LOAD_DELIVERYITEM.REQUEST:
      const { loading } = action.payload;
      return {
        ...state,
        loading: loading
      };
    case LOAD_DELIVERYITEM.SUCCESS:
      const { page } = action.payload;
      for (let i = 0; i < action.payload.lists.data.length; i++) {
        action.payload.lists.data[i].rowNumber = i + 1;
        if (page > 1)
          action.payload.lists.data[i].rowNumber =
            action.payload.lists.data[i].rowNumber + (page - 1) * 10;
      }
      return {
        ...state,
        lists: action.payload.lists.data,
        total:
          action.payload.lists.total - 1 <= 0
            ? 1
            : action.payload.lists.total <= 0
            ? 1
            : action.payload.lists.total,
        loading: false,
        draw: Math.floor(Math.random() * 999 + 1)
      };
    case LOAD_DELIVERYITEM_DETAIL.REQUEST:
      return {
        ...state,
        detailLoading: true
      };
    case LOAD_DELIVERYITEM_DETAIL.SUCCESS:
      return {
        ...state,
        selectedDeliveryItem: {
          ...action.payload.deliveryitem.data,
          detailData: action.payload.deliveryitem.detailData
        },
        detailLoading: false
      };
    case CREATE_DELIVERYITEM.SUCCESS:
      const { res } = action.payload;
      return {
        ...state,
        selectedDeliveryItem: {
          ...state.booking,
          deliveryitem_id: res.deliveryitem_id
        },
        deliveryitem_id: res.deliveryitem_id,
        detailLoading: false
      };
    case UPDATE_DELIVERYITEM.REQUEST:
      return {
        ...state,
        detailLoading: true
      };
    case UPDATE_DELIVERYITEM.SUCCESS:
      if (action.payload.res.status != "fail")
        return {
          ...state,
          detailLoading: false,
          selectedDeliveryItem: initialState.selectedDeliveryItem
        };
      else return { ...state, detailLoading: false };
    default:
      return state;
  }
};
